import { ReportType } from '@/shared/api/protocol-ts/model/dto_report_pb';
import { ToolNames } from '@/shared/config';

import type { GetToolbarControlsParams, ToolbarReportType } from '../config';
import {
  DEFAULT_SLICE_CONTROLS,
  MOBILE_EXCLUDED_TOOLS,
  REPORT_TOOLBAR_CONTROLS,
} from '../config';

const getSliceEditorControls = (hasScale?: boolean): ToolNames[] =>
  hasScale === false
    ? DEFAULT_SLICE_CONTROLS.filter((tool) => tool !== 'ruler')
    : DEFAULT_SLICE_CONTROLS;

const getMainControls = (
  reportType?: ReportType,
  isMobile?: boolean,
): ToolNames[] => {
  if (!reportType) {
    return [];
  }

  const controls =
    REPORT_TOOLBAR_CONTROLS[reportType as ToolbarReportType] ?? [];

  return isMobile
    ? controls.filter((tool) => !MOBILE_EXCLUDED_TOOLS.includes(tool))
    : controls;
};

export const getToolbarControls = ({
  toolbarID,
  reportType,
  hasScale,
  isMobile,
  isMaskEditingEnabled = false,
}: GetToolbarControlsParams): ToolNames[] => {
  if (toolbarID === 'sliceEditor') {
    return getSliceEditorControls(hasScale);
  }

  if (toolbarID === 'main') {
    return getMainControls(reportType, isMobile).filter(
      (tool) => tool !== 'editMask' || isMaskEditingEnabled,
    );
  }

  return [];
};
